"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _PFM4PJSGcjs = require('./PFM4PJSG.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');



var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/dialog/dialog-description.tsx
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var TagName = "p";
var useDialogDescription = _PTOCUU2Dcjs.createHook.call(void 0, function useDialogDescription2({ store, ...props }) {
  const setDescriptionId = _react.useContext.call(void 0, _PFM4PJSGcjs.DialogDescriptionContext);
  const id = _3BSDKDKDcjs.useId.call(void 0, props.id);
  _3BSDKDKDcjs.useSafeLayoutEffect.call(void 0, () => {
    setDescriptionId == null ? void 0 : setDescriptionId(id);
    return () => setDescriptionId == null ? void 0 : setDescriptionId(void 0);
  }, [setDescriptionId, id]);
  props = {
    ...props,
    id
  };
  return _misc.removeUndefinedValues.call(void 0, props);
});
var DialogDescription = _PTOCUU2Dcjs.forwardRef.call(void 0, function DialogDescription2(props) {
  const htmlProps = useDialogDescription(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useDialogDescription = useDialogDescription; exports.DialogDescription = DialogDescription;
